import React from 'react';
import { Logo } from './Logo';
import { CalendarIcon } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white border-b-4 border-passion-red shadow-sm" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-53">
        <div className="flex items-center gap-6" data-id="element-54">
          <Logo width={140} height={46} data-id="element-55" />
          <div className="hidden md:block h-8 w-px bg-tech-grey-25" data-id="element-56"></div>
          <div data-id="element-57">
            <h1 className="font-heading text-xl font-bold text-tech-grey leading-tight" data-id="element-58">
              Wettbewerbsanalyse für Polytec
            </h1>
            <div className="flex items-center text-sm text-tech-grey-50 font-body mt-0.5" data-id="element-59">
              <CalendarIcon className="w-4 h-4 mr-1.5 text-passion-red" data-id="element-60" />
              <span data-id="element-61">März 2026</span>
            </div>
          </div>
        </div>
      </div>
    </header>;
}